const UitkLinkThemeMap = [
  ["default", "default"],
  ["inverse", "inverse"]
];
export const UitkLinkThemes = new Map(UitkLinkThemeMap);
const UitkLinkSizeMap = [
  ["small", "small"],
  ["medium", "medium"],
  ["large", "large"]
];
export const UitkLinkSizes = new Map(UitkLinkSizeMap);
const UitkLinkAlignMap = [
  ["left", "left"],
  ["center", "center"],
  ["right", "right"]
];
export const UitkLinkAligns = new Map(UitkLinkAlignMap);
